var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisionaiLogout(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.001,
    height: 18,
    viewBox: "0 0 18.001 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_106350",
    "data-name": "Path 106350",
    d: "M42.5,988.25a.751.751,0,0,1-.75.75H36.5a1.5,1.5,0,0,1-1.5-1.5v-15a1.5,1.5,0,0,1,1.5-1.5h5.25a.75.75,0,0,1,0,1.5H36.5v15h5.25a.751.751,0,0,1,.75.75Zm10.281-8.781-3.75-3.75a.751.751,0,0,0-1.061,1.062l2.47,2.469H41.75a.75.75,0,0,0,0,1.5h8.69l-2.47,2.469a.751.751,0,0,0,1.061,1.062l3.75-3.75a.755.755,0,0,0,.163-.244.749.749,0,0,0,0-.574A.755.755,0,0,0,52.781,979.469Z",
    transform: "translate(-35 -971)",
    fill: "#1c1c1c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisionaiLogout);
export default __webpack_public_path__ + "static/media/visionai_logout.b33b91ecc743a991b18120f355781bf5.svg";
export { ForwardRef as ReactComponent };